import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53343c5f")

_pushScopeId("data-v-53343c5f")
const _hoisted_1 = { class: "ai-analysis-container" }
const _hoisted_2 = { class: "history-panel" }
const _hoisted_3 = { class: "history-header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", null, "历史记录", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_6 = { class: "history-list" }
const _hoisted_7 = { class: "history-info" }
const _hoisted_8 = { class: "history-title" }
const _hoisted_9 = { class: "history-time" }
const _hoisted_10 = {
  key: 0,
  class: "empty-history"
}
const _hoisted_11 = { class: "chat-panel" }
const _hoisted_12 = { class: "chat-header" }
const _hoisted_13 = /*#__PURE__*/_createVNode("h2", null, "AI分析", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("新建分析")
const _hoisted_15 = {
  key: 0,
  class: "empty-chat"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("p", null, "请输入股票或转债代码进行AI分析", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "tip" }, "每次分析消耗15积分", -1)
const _hoisted_18 = { class: "message-content" }
const _hoisted_19 = {
  key: 0,
  class: "user-message"
}
const _hoisted_20 = { class: "message-text" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "code" }
const _hoisted_23 = {
  key: 0,
  class: "name"
}
const _hoisted_24 = {
  key: 1,
  class: "ai-message"
}
const _hoisted_25 = {
  key: 1,
  class: "loading-message"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "el-icon-loading" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", null, "AI正在分析中...", -1)
const _hoisted_28 = { class: "chat-input" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("正股")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("转债")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 分析（15积分） ")
_popScopeId()

import { ref, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { marked } from 'marked'
import api from '@/api'


interface Message {
  role: 'user' | 'assistant'
  content: string
  type?: string
  symbol?: string
  name?: string
}

interface HistoryItem {
  id: number
  name: string
  type: string
  symbol: string
  timestamp: string
  messages: Message[]
}


export default _defineComponent({
  expose: [],
  setup(__props) {

const route = useRoute()
const historyList = ref<HistoryItem[]>([])
const messages = ref<Message[]>([])
const loading = ref(false)
const currentHistoryId = ref<number | null>(null)
const chatContent = ref<HTMLElement>()

const form = ref({
  type: 'bond',
  symbol: ''
})

onMounted(() => {
  loadHistoryList()
  
  // 检查是否有从其他页面传递过来的params参数
  if (route.params.symbol) {
    form.value.type = route.params.type as string || 'bond'
    form.value.symbol = route.params.symbol as string
    // 如果有传递名称，也保存下来（用于显示，不影响接口）
    const paramName = route.params.name as string
    // 自动触发分析
    nextTick(() => {
      submitAnalysis(paramName)
    })
  }
})

// 本地存储相关方法
const STORAGE_KEY = 'ai_analysis_history'

const getAiHistory = () => {
  const history = localStorage.getItem(STORAGE_KEY)
  return history ? JSON.parse(history) : []
}

const saveAiHistory = (record: any) => {
  const history = getAiHistory()
  history.unshift({
    ...record,
    id: Date.now(),
    timestamp: new Date().toISOString()
  })
  // 最多保存100条记录
  if (history.length > 100) {
    history.pop()
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(history))
}

const deleteAiHistory = (id: number) => {
  const history = getAiHistory()
  const newHistory = history.filter((item: any) => item.id !== id)
  localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory))
}

const clearAiHistoryStorage = () => {
  localStorage.removeItem(STORAGE_KEY)
}

const loadHistoryList = () => {
  historyList.value = getAiHistory()
}

const newAnalysis = () => {
  messages.value = []
  currentHistoryId.value = null
  form.value.symbol = ''
}

const submitAnalysis = async (initialName?: string | Event) => {
  if (!form.value.symbol.trim()) {
    ElMessage.warning('请输入代码')
    return
  }
  
  if (loading.value) return
  
  // 如果传入的是事件对象，则忽略它
  const name = (typeof initialName === 'string') ? initialName : ''
  
  // 参数校验和清理
  let symbol = form.value.symbol.trim()
  
  // 去掉开头的sz、sh、SZ、SH
  symbol = symbol.replace(/^(sz|sh|SZ|SH)/i, '')
  
  // 验证是否为6位数字
  if (!/^\d{6}$/.test(symbol)) {
    ElMessage.error('请输入正确的6位代码')
    return
  }
  
  loading.value = true
  const type = form.value.type
  
  // 添加用户消息
  const userMessage: Message = {
    role: 'user',
    type,
    symbol,
    name: name, // 使用处理后的名称
    content: `分析${type === 'stock' ? '正股' : '转债'}：${symbol}${name ? ` (${name})` : ''}`
  }
  messages.value.push(userMessage)
  
  scrollToBottom()
  
  // 立即创建历史记录（请求发起时）
  const recordId = Date.now()
  const displayName = name ? `${name} (${symbol})` : symbol
  const initialRecord = {
    id: recordId,
    name: `${displayName} - ${type === 'stock' ? '正股' : '转债'}`,
    type,
    symbol,
    timestamp: new Date().toISOString(),
    messages: [...messages.value]
  }
  saveAiHistory(initialRecord)
  loadHistoryList()
  currentHistoryId.value = recordId
  
  // AI消息对象（先不添加到messages，等有内容时再添加）
  const aiMessage: Message = {
    role: 'assistant',
    content: ''
  }
  
  try {
    // 调用API获取完整结果
    const result = await api.aiAnalysis({ type, symbol })
    
    console.log(result)
    if (result) {
      const analysisText = result.analysis || ''
      
      // 添加AI消息到列表
      messages.value.push(aiMessage)
      
      // 模拟流式输出效果
      await simulateStreamOutput(analysisText, aiMessage)
      
      // 更新历史记录（添加完整的分析结果）
      updateHistoryRecord(recordId, userMessage)
    } else {
      // 添加错误消息
      aiMessage.content = result?.msg || '分析失败'
      messages.value.push(aiMessage)
      ElMessage.error(result?.msg || '分析失败')
      // 更新历史记录
      updateHistoryRecord(recordId, userMessage)
    }
    
  } catch (error: any) {
    // 添加错误消息
    aiMessage.content = error.message || '分析失败，请稍后重试'
    messages.value.push(aiMessage)
    ElMessage.error(error.message || '分析失败')
    // 更新历史记录
    updateHistoryRecord(recordId, userMessage)
  } finally {
    loading.value = false
    form.value.symbol = ''
    scrollToBottom()
  }
}

// 模拟流式输出效果
const simulateStreamOutput = (text: string, message: Message) => {
  return new Promise<void>((resolve) => {
    let index = 0
    const chunkSize = 10 // 每次显示的字符数
    const interval = 30 // 间隔时间（毫秒）
    
    const timer = setInterval(() => {
      if (index < text.length) {
        index += chunkSize
        message.content = text.substring(0, index)
        scrollToBottom()
      } else {
        message.content = text
        clearInterval(timer)
        resolve()
      }
    }, interval)
  })
}

// 更新历史记录（只更新消息内容，不更改名称）
const updateHistoryRecord = (recordId: number, userMessage: Message) => {
  const history = getAiHistory()
  const recordIndex = history.findIndex((item: any) => item.id === recordId)
  
  if (recordIndex !== -1) {
    // 只更新消息内容，保持原有的名称不变
    history[recordIndex] = {
      ...history[recordIndex],
      messages: messages.value
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history))
    loadHistoryList()
  }
}

const loadHistory = (item: HistoryItem) => {
  currentHistoryId.value = item.id
  messages.value = item.messages
  scrollToBottom()
}

const deleteHistory = (id: number) => {
  ElMessageBox.confirm('确定删除这条历史记录吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    deleteAiHistory(id)
    loadHistoryList()
    if (currentHistoryId.value === id) {
      newAnalysis()
    }
    ElMessage.success('删除成功')
  }).catch(() => {})
}

const clearHistory = () => {
  ElMessageBox.confirm('确定清空所有历史记录吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    clearAiHistoryStorage()
    loadHistoryList()
    newAnalysis()
    ElMessage.success('清空成功')
  }).catch(() => {})
}

const formatTime = (timestamp: string) => {
  const date = new Date(timestamp)
  const now = new Date()
  const diff = now.getTime() - date.getTime()
  
  if (diff < 60000) return '刚刚'
  if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`
  
  return `${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`
}

const formatMessage = (content: string) => {
  if (!content) return ''
  
  // 使用 marked 解析 Markdown
  try {
    // 配置 marked 选项
    marked.setOptions({
      breaks: true, // 支持 GitHub 风格的换行
      gfm: true, // 启用 GitHub 风格的 Markdown
    })
    return marked.parse(content)
  } catch (error) {
    console.error('Markdown 解析错误:', error)
    // 如果解析失败，回退到简单的换行处理
    return content.replace(/\n/g, '<br>')
  }
}

const scrollToBottom = () => {
  nextTick(() => {
    if (chatContent.value) {
      chatContent.value.scrollTop = chatContent.value.scrollHeight
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (historyList.value.length)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "small",
              onClick: clearHistory,
              disabled: loading.value
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(historyList.value, (item) => {
          return (_openBlock(), _createBlock("div", {
            key: item.id,
            class: ["history-item", { active: currentHistoryId.value === item.id, disabled: loading.value }],
            onClick: ($event: any) => (!loading.value && loadHistory(item))
          }, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
              _createVNode("div", _hoisted_9, _toDisplayString(formatTime(item.timestamp)), 1)
            ]),
            _createVNode("i", {
              class: "el-icon-close delete-icon",
              onClick: _withModifiers(($event: any) => (deleteHistory(item.id)), ["stop"])
            }, null, 8, ["onClick"])
          ], 10, ["onClick"]))
        }), 128)),
        (!historyList.value.length)
          ? (_openBlock(), _createBlock("div", _hoisted_10, "暂无历史记录"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: newAnalysis,
          disabled: loading.value
        }, {
          default: _withId(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createVNode("div", {
        class: "chat-content",
        ref: chatContent
      }, [
        (!messages.value.length)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _hoisted_16,
              _hoisted_17
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(messages.value, (msg, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: ["message-item", msg.role]
          }, [
            _createVNode("div", _hoisted_18, [
              (msg.role === 'user')
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("span", _hoisted_21, _toDisplayString(msg.type === 'stock' ? '正股' : '转债') + "：", 1),
                      _createVNode("span", _hoisted_22, _toDisplayString(msg.symbol), 1),
                      (msg.name)
                        ? (_openBlock(), _createBlock("span", _hoisted_23, _toDisplayString(msg.name), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (msg.role!=='user' && msg.content)
                ? (_openBlock(), _createBlock("div", _hoisted_24, [
                    _createVNode("div", {
                      class: "markdown-body",
                      innerHTML: formatMessage(msg.content)
                    }, null, 8, ["innerHTML"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2))
        }), 128)),
        (loading.value)
          ? (_openBlock(), _createBlock("div", _hoisted_25, [
              _hoisted_26,
              _hoisted_27
            ]))
          : _createCommentVNode("", true)
      ], 512),
      _createVNode("div", _hoisted_28, [
        _createVNode(_component_el_form, {
          model: form.value,
          onSubmit: _withModifiers(submitAnalysis, ["prevent"])
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.value.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (form.value.type = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_radio, { label: "stock" }, {
                      default: _withId(() => [
                        _hoisted_29
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "bond" }, {
                      default: _withId(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.symbol,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (form.value.symbol = $event)),
                  placeholder: "请输入6位代码（如：603393 或 sh603393）",
                  disabled: loading.value,
                  onKeyup: _withKeys(submitAnalysis, ["enter"])
                }, {
                  append: _withId(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: submitAnalysis,
                      loading: loading.value,
                      disabled: !form.value.symbol.trim()
                    }, {
                      default: _withId(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "onKeyup"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "onSubmit"])
      ])
    ])
  ]))
}
}

})